import React, {useCallback, useEffect, useRef, useState} from "react";
import { useParams } from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";

import {getCmsPageTitle, getCmsPageContent} from "@awe-web/shared/lib";
import {ScreenSection, ScreenHeading} from "../../components/screen.js";
import {TypeArea} from "../../components/layout.js";
import {Row, Col} from "../../components/grid.js";
import {CmsContent} from "../../cms/components/cms_content.js";
import {PolicyPage} from "../../consent_controller/components/consent_controller.js";
import {loadCmsPage} from "../../cms/actions.js";

import "./cms.scss";

export default function CmsPage() {
  const dispatch = useDispatch();
  const {pageName} = useParams();
  const [isReady, setIsReady] = useState(false);
  const isUnmounted = useRef(false);

  const pageTitle = useSelector(state => getCmsPageTitle(state, {pageName: pageName}));
  const pageContent = useSelector(state => getCmsPageContent(state, {pageName: pageName}));

  const init = useCallback(async () => {
    if (!pageName || pageName.length === 0) {
      return;
    }

    try {
        await dispatch(loadCmsPage(pageName));
        if (!isUnmounted.current) {
          setIsReady(true);
        }
    } catch (error) {
      if (!isUnmounted.current) {
        setIsReady(false);
      }
    }
  }, [dispatch, pageName]);

  useEffect(() => {
      init();
  
      return () => {
        isUnmounted.current = true;
      };
    }, [init]);


  if (!isReady) {
    return null;
  }

  return (
    <>
      <ScreenSection dark>
        <TypeArea>
          <Row>
            <Col desktop={{cols: 8, offset: 2}}>
              <ScreenHeading className="cms__screen-heading">
                {pageTitle}
              </ScreenHeading>
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>
      <ScreenSection main>
        <TypeArea>
          <Row>
            <Col desktop={{cols: 8, offset: 2}}>
              <CmsContent className="cms__content" pageName={pageName} pageContent={pageContent} />
            </Col>
          </Row>
        </TypeArea>
      </ScreenSection>

      {pageName === "cookies"
        ? (
          <TypeArea>
            <Row>
              <Col>
                <PolicyPage />
              </Col>
            </Row>
          </TypeArea>
        )
        : null
      }
    </>
  );
}
